export enum PatientPaymentTypes {
    Cash = 1,
    Cheque = 2, 
    Visa = 3,
    BankTransfer = 4,
    Installment = 5,
}
